import { DISPLAY, GOVDE, ALTIN, INK, INK_2, KAGIT, KAGIT_2, BLOK } from "./data/constants";
import { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, useParams, Navigate } from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ServicesListPage from "./pages/ServicesListPage";
import ServicePage from "./pages/ServicePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";

const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));

const LazyFallback = () => (
  <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div style={{ textAlign: "center" }}>
      <div style={{ width: 40, height: 40, border: `3px solid ${ALTIN}`, borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
      <span style={{ fontFamily: GOVDE, fontSize: 13, color: INK_2 }}>Yükleniyor...</span>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  </div>
);

/* Bu dosya renkleri kendi içinde sabit tutuyordu, bu yüzden tema
   değiştiğinde sabit buton eski paletle kalıyordu. Artık tokenlardan
   besleniyor. */
const GOLD = ALTIN;
const NAVY = INK;

// ─── STICKY CTA ───────────────────────────────────────────────────────────────
function StickyAnaliz() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <div style={{
      position: "fixed", bottom: 28, right: 24, zIndex: 998,
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(20px)",
      transition: "opacity 0.4s ease, transform 0.4s ease",
      pointerEvents: visible ? "auto" : "none",
    }}>
      {!expanded && (
        <>
          <style>{`@keyframes ctaPulse { 0% { transform: scale(1); opacity: 0.6; } 100% { transform: scale(1.7); opacity: 0; } }`}</style>
          <div style={{ position: "absolute", inset: 0, borderRadius: 50, background: GOLD, animation: "ctaPulse 2s ease-out infinite", pointerEvents: "none" }} />
        </>
      )}
      <button onClick={() => setExpanded(p => !p)} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
        style={{ position: "relative", background: expanded ? NAVY : GOLD, color: expanded ? GOLD : NAVY, border: "none", borderRadius: 50, width: expanded ? "auto" : 56, height: 56, padding: expanded ? "0 22px" : 0, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer", boxShadow: hovered ? "0 12px 40px rgba(168,121,42,0.5)" : "0 6px 24px rgba(168,121,42,0.35)", transition: "all 0.3s ease", whiteSpace: "nowrap", fontFamily: GOVDE, fontSize: 13, fontWeight: 700 }}>
        {/* Emoji temizliğinde bu ikon boşalmıştı ve buton içi boş bir daire
            olarak çıkıyordu. Yerine çizgi ikon kondu: emoji değil, rengi
            yazıdan alıyor, her ölçekte net. */}
        {expanded ? <span style={{ fontSize: 16 }}>✕</span> : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"
               stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.9 8.9 0 0 1-3.8-.9L3 21l1.9-5.1A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z" />
          </svg>
        )}
      </button>
      <div style={{ position: "absolute", bottom: 68, right: 0, width: 260, background: KAGIT, borderRadius: 16, boxShadow: "0 20px 60px rgba(18,18,15,0.18)", overflow: "hidden", maxHeight: expanded ? "400px" : "0px", opacity: expanded ? 1 : 0, transition: "max-height 0.35s ease, opacity 0.3s ease", pointerEvents: expanded ? "auto" : "none" }}>
        <div style={{ background: BLOK, padding: "20px 20px 16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
            <div style={{ width: 32, height: 32, background: GOLD, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ color: NAVY, fontFamily: "serif", fontWeight: 900, fontSize: 15 }}>W</span>
            </div>
            <div>
              <div style={{ fontFamily: DISPLAY, fontSize: 13, fontWeight: 700, color: KAGIT }}>Whayns Dijital</div>
            </div>
          </div>
          <p style={{ fontFamily: GOVDE, fontSize: 13, color: "rgba(255,255,255,0.7)", margin: 0, lineHeight: 1.6 }}>Markanız için ücretsiz analiz görüşmesi yapalım.</p>
        </div>
        <div style={{ padding: "16px 20px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
          <button onClick={() => { navigate("/iletisim"); setExpanded(false); }} style={{ background: GOLD, color: NAVY, border: "none", borderRadius: 8, padding: "12px 16px", fontFamily: GOVDE, fontSize: 13, fontWeight: 700, cursor: "pointer", textAlign: "center" }}>Ücretsiz Analiz Al →</button>
          <a href="https://wa.me/908502428674" target="_blank" rel="noreferrer" style={{ background: "#0F7A40", color: "#FFFFFF", borderRadius: 8, padding: "11px 16px", fontFamily: GOVDE, fontSize: 13, fontWeight: 700, textAlign: "center", textDecoration: "none", display: "block" }}>WhatsApp ile Yaz</a>
          <a href="tel:+908502428674" style={{ background: KAGIT_2, color: NAVY, borderRadius: 8, padding: "11px 16px", fontFamily: GOVDE, fontSize: 13, fontWeight: 600, textAlign: "center", textDecoration: "none", display: "block" }}>Bizi Ara</a>
          <a href="mailto:destek@whaynsdijital.com" style={{ background: KAGIT_2, color: NAVY, borderRadius: 8, padding: "11px 16px", fontFamily: GOVDE, fontSize: 13, fontWeight: 600, textAlign: "center", textDecoration: "none", display: "block" }}>E-posta Gönder</a>
        </div>
      </div>
    </div>
  );
}

// ─── LAYOUT (NavBar + Footer) ─────────────────────────────────────────────────
function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const serviceIds = ["brand","ads","production","social","trendyol","mail","research","web","seo"];
  const handleNavigate = (page) => {
    const map = {
      home: "/", services: "/hizmetler", about: "/hakkimizda",
      contact: "/iletisim", blog: "/blog",
    };
    if (map[page]) { navigate(map[page]); return; }
    if (page.startsWith("blog-")) { navigate("/blog/" + page.replace("blog-", "")); return; }
    if (serviceIds.includes(page)) { navigate("/hizmetler/" + page); return; }
    navigate("/" + page);
  };

  return (
    <div style={{ fontFamily: GOVDE, margin: 0, padding: 0, overflowX: "hidden" }}>
      <NavBar onNavigate={handleNavigate} currentPage={location.pathname} />
      <main>{children}</main>
      <Footer onNavigate={handleNavigate} />
      <StickyAnaliz />
    </div>
  );
}

// ─── ROUTER WRAPPER ───────────────────────────────────────────────────────────
function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [location.pathname]);

  const serviceIds = ["brand","ads","production","social","trendyol","mail","research","web","seo"];
  const nav = (page) => {
    const map = {
      home: "/", services: "/hizmetler", about: "/hakkimizda",
      contact: "/iletisim", blog: "/blog",
    };
    if (map[page]) { navigate(map[page]); return; }
    if (page.startsWith("blog-")) { navigate("/blog/" + page.replace("blog-", "")); return; }
    if (serviceIds.includes(page)) { navigate("/hizmetler/" + page); return; }
    navigate("/" + page);
  };

  return (
    <Suspense fallback={<LazyFallback />}>
    <Routes>
      {/* Admin: NavBar/Footer yok */}
      <Route path="/admin" element={<AdminPage />} />

      {/* Normal sayfalar */}
      <Route path="/" element={<Layout><HomePage onNavigate={nav} /></Layout>} />
      <Route path="/hizmetler" element={<Layout><ServicesListPage onNavigate={nav} /></Layout>} />
      <Route path="/hizmetler/:serviceId" element={<ServiceRouteWrapper onNavigate={nav} />} />
      <Route path="/hakkimizda" element={<Layout><AboutPage onNavigate={nav} /></Layout>} />
      <Route path="/iletisim" element={<Layout><ContactPage onNavigate={nav} /></Layout>} />
      <Route path="/blog" element={<Layout><BlogPage onNavigate={nav} /></Layout>} />
      <Route path="/blog/:postId" element={<BlogPostRouteWrapper onNavigate={nav} />} />

      {/* Bilinmeyen adres: ana sayfaya yönlendirmek YUMUŞAK 404 üretiyordu
          (arama motoru sayfayı "var" sanıp kopya içerik sayıyor). */}
      <Route path="*" element={<Layout><NotFoundPage onNavigate={nav} /></Layout>} />
    </Routes>
    </Suspense>
  );
}

function ServiceRouteWrapper({ onNavigate }) {
  const { serviceId } = useParams();
  return <Layout><ServicePage serviceId={serviceId} onNavigate={onNavigate} /></Layout>;
}

function BlogPostRouteWrapper({ onNavigate }) {
  const { postId } = useParams();
  return <Layout><BlogPostPage postId={postId} onNavigate={onNavigate} /></Layout>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}